import { BoxStatus } from "./models.ts";

export const enum ValidationEvents {
  FILLED = "validation_filled",
  HYDRATED = "validation_hydrated",
  COMPLETED = "validation_completed",
  EDITED = "validation_edited",
  IN_REVIEW_FOCUSED = "validation_focused",
  OPTIONAL_FOCUSED = "validation_optional_focused",
  BOX_STATUS_CHANGED = "box_status_changed",
}

export type FilledEvent = {
  type: ValidationEvents.FILLED;
  id: string;
  isFilled: boolean;
};

export type HydratedEvent = {
  type: ValidationEvents.HYDRATED;
  id: string;
};

export type CompletedEvent = {
  type: ValidationEvents.COMPLETED;
  id: string;
};

export type EditedEvent = {
  type: ValidationEvents.EDITED;
  id: string;
};

export type InReviewFocusedEvent = {
  type: ValidationEvents.IN_REVIEW_FOCUSED;
  id: string;
};

export type OptionalFocusedEvent = {
  type: ValidationEvents.OPTIONAL_FOCUSED;
  id: string;
};

export type BoxStatusChangedEvent = {
  type: ValidationEvents.BOX_STATUS_CHANGED;
  id: string;
  status: BoxStatus;
};

export type ValidationEvent =
  | FilledEvent
  | HydratedEvent
  | CompletedEvent
  | EditedEvent
  | InReviewFocusedEvent
  | OptionalFocusedEvent
  | BoxStatusChangedEvent;

export function fireEvent(type: ValidationEvents, data: Omit<ValidationEvent, "type">) {
  const event = new CustomEvent(type, { detail: data });
  dispatchEvent(event);
}
